import { useFilters } from '@/composables/front/formatters/useFilters';
import { isPlazoPagable } from '@/composables/front/perfil/plazos';

const ESTADO_VARIANTS = { 0: 'warning', 1: 'success', 2: 'default', 3: 'danger', 4: 'danger', 5: 'danger' };
const ESTADO_I18N = { 0: 'perfil.pendiente', 1: 'perfil.pagado', 2: 'perfil.anulado', 3: 'perfil.pendiente', 4: 'perfil.pendiente', 5: 'perfil.pendiente' };

export function usePlazos() {
    const { formatearPrecio, formatearFecha } = useFilters();

    const importeOriginal = plazo => {
        const base = plazo.importe_con_gd ?? plazo.importe ?? 0;
        return base + (plazo.descuento_aplicado ?? 0);
    };

    const estadoVariant = estado => ESTADO_VARIANTS[estado] ?? 'default';
    const estadoI18nKey = estado => ESTADO_I18N[estado] ?? null;

    return {
        formatearPrecio,
        formatearFecha,
        isPagable: isPlazoPagable,
        importeOriginal,
        estadoVariant,
        estadoI18nKey,
    };
}
